"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("stremio/core");
var styles_less_1 = __importDefault(require("./styles.less"));
var isExcludedCoreAddon = require('stremio/caroline/addons/plan').isExcludedCoreAddon;
var request = function (path, init) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(path, __assign({ credentials: 'same-origin', cache: 'no-store' }, init))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    error = new Error("HTTP ".concat(response.status));
                    Object.assign(error, { status: response.status });
                    throw error;
                }
                return [2 /*return*/, response.status === 204 ? null : response.json()];
        }
    });
}); };
var CarolineAdmin = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var core = (0, core_1.useCore)();
    var _a = (0, react_1.useState)('loading'), status = _a[0], setStatus = _a[1];
    var _b = (0, react_1.useState)([]), items = _b[0], setItems = _b[1];
    var _c = (0, react_1.useState)([]), defaultAddons = _c[0], setDefaultAddons = _c[1];
    var _d = (0, react_1.useState)(''), name = _d[0], setName = _d[1];
    var _e = (0, react_1.useState)(''), transportUrl = _e[0], setTransportUrl = _e[1];
    var _f = (0, react_1.useState)(null), busyId = _f[0], setBusyId = _f[1];
    var _g = (0, react_1.useState)(null), message = _g[0], setMessage = _g[1];
    var load = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1, httpStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request('/api/admin/addons')];
                case 1:
                    result = _a.sent();
                    setItems(result.items);
                    setStatus('ready');
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    httpStatus = error_1.status;
                    setStatus(httpStatus === 401 ? 'auth-required' : httpStatus === 403 ? 'denied' : 'unavailable');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        load();
    }, [load]);
    (0, react_1.useEffect)(function () {
        var active = true;
        core.transport.getState('ctx').then(function (ctx) {
            var _a;
            if (!active)
                return;
            var addons = Array.isArray((_a = ctx === null || ctx === void 0 ? void 0 : ctx.profile) === null || _a === void 0 ? void 0 : _a.addons) ? ctx.profile.addons : [];
            setDefaultAddons(addons.filter(function (addon) { return typeof (addon === null || addon === void 0 ? void 0 : addon.transportUrl) === 'string' && !isExcludedCoreAddon(addon); }).map(function (addon) {
                var _a, _b;
                return ({
                    id: "default:".concat(addon.transportUrl),
                    name: ((_a = addon.manifest) === null || _a === void 0 ? void 0 : _a.name) || ((_b = addon.manifest) === null || _b === void 0 ? void 0 : _b.id) || addon.transportUrl,
                    transportUrl: addon.transportUrl,
                    enabled: true,
                    isInstalledOnProfile: true,
                });
            }));
        }).catch(function () { return setDefaultAddons([]); });
        return function () { active = false; };
    }, [core]);
    var onAdd = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setMessage(null);
                    setBusyId('new');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, request('/api/admin/addons', {
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            body: JSON.stringify({ name: name, transportUrl: transportUrl }),
                        })];
                case 2:
                    _a.sent();
                    setName('');
                    setTransportUrl('');
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _1 = _a.sent();
                    setMessage(t('CAROLINE_ADMIN_ADD_FAILED', { defaultValue: 'Não foi possível adicionar este addon. Verifica o nome e o URL do manifesto.' }));
                    return [3 /*break*/, 6];
                case 5:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onManageDefault = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMessage(null);
                    setBusyId(item.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, request('/api/admin/addons', {
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            body: JSON.stringify({ name: item.name, transportUrl: item.transportUrl, enabled: true }),
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _2 = _a.sent();
                    setMessage(t('CAROLINE_ADMIN_ADD_FAILED', { defaultValue: 'Não foi possível incluir este addon na gestão Caroline.' }));
                    return [3 /*break*/, 6];
                case 5:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onToggle = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setMessage(null);
                    setBusyId(item.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, request("/api/admin/addons/".concat(encodeURIComponent(item.id)), {
                            method: 'PATCH',
                            headers: { 'content-type': 'application/json' },
                            body: JSON.stringify({ enabled: !item.enabled }),
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _3 = _a.sent();
                    setMessage(t('CAROLINE_ADMIN_UPDATE_FAILED', { defaultValue: 'Não foi possível atualizar o addon.' }));
                    return [3 /*break*/, 6];
                case 5:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var visibleItems = (function () {
        var managed = new Map(items.map(function (item) { return [item.transportUrl, __assign(__assign({}, item), { isManaged: true })]; }));
        for (var _i = 0, defaultAddons_1 = defaultAddons; _i < defaultAddons_1.length; _i++) {
            var addon = defaultAddons_1[_i];
            var existing = managed.get(addon.transportUrl);
            if (existing)
                existing.isInstalledOnProfile = true;
            else
                managed.set(addon.transportUrl, __assign(__assign({}, addon), { isManaged: false }));
        }
        return __spreadArray([], managed.values(), true);
    })();
    var onRemove = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm(t('CAROLINE_ADMIN_REMOVE_CONFIRM', { defaultValue: 'Remover este addon da lista de clientes?' })))
                        return [2 /*return*/];
                    setMessage(null);
                    setBusyId(item.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, request("/api/admin/addons/".concat(encodeURIComponent(item.id)), { method: 'DELETE' })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, load()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    _4 = _a.sent();
                    setMessage(t('CAROLINE_ADMIN_REMOVE_FAILED', { defaultValue: 'Não foi possível remover o addon.' }));
                    return [3 /*break*/, 6];
                case 5:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("main", { className: styles_less_1.default['page'] },
        react_1.default.createElement("div", { className: styles_less_1.default['content'] },
            react_1.default.createElement("header", { className: styles_less_1.default['header'] },
                react_1.default.createElement("a", { href: "#/" }, t('CAROLINE_ADMIN_BACK_HOME', { defaultValue: 'Voltar ao Início' })),
                react_1.default.createElement("p", null, t('CAROLINE_APP_NAME', { defaultValue: 'Caroline' })),
                react_1.default.createElement("h1", null, t('CAROLINE_ADMIN_TITLE', { defaultValue: 'Administração de addons' })),
                react_1.default.createElement("span", null, t('CAROLINE_ADMIN_DESCRIPTION', { defaultValue: 'Escolhe os addons disponibilizados aos clientes.' }))),
            status === 'auth-required' && react_1.default.createElement("div", { className: styles_less_1.default['notice'] },
                react_1.default.createElement("p", null, t('CAROLINE_ADMIN_SIGN_IN', { defaultValue: 'Inicia sessão com a conta de administrador Caroline.' })),
                react_1.default.createElement("a", { href: "#/caroline-auth" }, t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' }))),
            status === 'loading' && react_1.default.createElement("p", { role: "status" }, t('CAROLINE_ADMIN_LOADING', { defaultValue: 'A carregar addons…' })),
            status === 'denied' && react_1.default.createElement("p", { role: "alert" }, t('CAROLINE_ADMIN_DENIED', { defaultValue: 'Esta conta não tem permissão de administração.' })),
            status === 'unavailable' && react_1.default.createElement("p", { role: "alert" }, t('CAROLINE_ADMIN_UNAVAILABLE', { defaultValue: 'A administração ainda não está configurada ou o serviço está indisponível.' })),
            status === 'ready' && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("form", { className: styles_less_1.default['form'], onSubmit: onAdd },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("span", null, t('CAROLINE_ADMIN_ADDON_NAME', { defaultValue: 'Nome do addon' })),
                        react_1.default.createElement("input", { value: name, onChange: function (event) { return setName(event.target.value); }, maxLength: 120, required: true })),
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("span", null, t('CAROLINE_ADMIN_MANIFEST_URL', { defaultValue: 'URL HTTPS do manifesto' })),
                        react_1.default.createElement("input", { value: transportUrl, onChange: function (event) { return setTransportUrl(event.target.value); }, type: "url", placeholder: "https://example.com/manifest.json", required: true })),
                    react_1.default.createElement("button", { type: "submit", disabled: busyId !== null }, t('CAROLINE_ADMIN_ADD', { defaultValue: 'Adicionar addon' }))),
                message && react_1.default.createElement("p", { role: "alert", className: styles_less_1.default['error'] }, message),
                react_1.default.createElement("section", { className: styles_less_1.default['list'], "aria-label": t('CAROLINE_ADMIN_LIST', { defaultValue: 'Addons disponíveis' }) },
                    react_1.default.createElement("h2", null, t('CAROLINE_ADMIN_LIST', { defaultValue: 'Addons disponíveis' })),
                    visibleItems.length === 0 && react_1.default.createElement("p", null, t('CAROLINE_ADMIN_EMPTY', { defaultValue: 'Ainda não adicionaste addons.' })),
                    visibleItems.map(function (item) { return react_1.default.createElement("article", { key: item.transportUrl, className: styles_less_1.default['item'] },
                        react_1.default.createElement("div", { className: styles_less_1.default['item-info'] },
                            react_1.default.createElement("h3", null, item.name),
                            react_1.default.createElement("p", null, item.transportUrl),
                            react_1.default.createElement("small", null, item.enabled
                                ? t('CAROLINE_ADMIN_ACTIVE', { defaultValue: 'Disponível aos clientes' })
                                : t('CAROLINE_ADMIN_INACTIVE', { defaultValue: 'Desativado' })),
                            item.isInstalledOnProfile && react_1.default.createElement("small", null, t('CAROLINE_ADMIN_PROFILE_ADDON', { defaultValue: 'Já instalado neste perfil' }))),
                        react_1.default.createElement("div", { className: styles_less_1.default['actions'] }, !item.isManaged
                            ? react_1.default.createElement("button", { type: "button", disabled: busyId !== null, onClick: function () { return onManageDefault(item); } }, t('CAROLINE_ADMIN_MANAGE_DEFAULT', { defaultValue: 'Incluir na gestão' }))
                            : react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("button", { type: "button", disabled: busyId !== null, onClick: function () { return onToggle(item); } }, item.enabled ? t('CAROLINE_ADMIN_DISABLE', { defaultValue: 'Desativar' }) : t('CAROLINE_ADMIN_ENABLE', { defaultValue: 'Ativar' })),
                                react_1.default.createElement("button", { type: "button", disabled: busyId !== null, onClick: function () { return onRemove(item); } }, t('CAROLINE_ADMIN_REMOVE', { defaultValue: 'Remover' }))))); }))))));
};
exports.default = CarolineAdmin;
